import React from 'react'
import '../App.css'
import Bodyrecopass from './bodyrecopass'
export class Bodyapprecopassbody extends React.Component {
    constructor(props){
        super (props)
    }
    render() {       
        return (
            <div className='sshbodyapp'>
                <div className='sshbodyappContainer'>
                    <Bodyrecopass/>
                </div>
            </div>
        );
    }
}